import React from 'react'
import { Link } from 'react-router-dom'
import { PAGINE } from '../pages'
import { Formatter, useSelector } from 'gf-ui'

const Footer = ({tipologia, backlink}) => {
    
    const datiAziendali = useSelector( state => state?.page?.data?.datiAziendali )

    return <footer className='w-100 bg-secondary text-light text-center p-4'>                    
        <div>
            <div>{datiAziendali?.nome}</div>
            <div>
                {!Formatter.isStringaVuota(datiAziendali?.indirizzo) && datiAziendali?.indirizzo }
                {!Formatter.isStringaVuota(datiAziendali?.telefono) && <> Telefono: {datiAziendali?.telefono}</>} 
                {!Formatter.isStringaVuota(datiAziendali?.email) && <> Mail: {datiAziendali?.email}</>} 
                {!Formatter.isStringaVuota(datiAziendali?.pec) && <> Mail Certificata: {datiAziendali?.pec}</>}
            </div>
            <div>
                {!Formatter.isStringaVuota(datiAziendali?.cf) && <> C.F.: {datiAziendali?.cf}</>}
                {!Formatter.isStringaVuota(datiAziendali?.piva) && <> P.IVA: {datiAziendali?.piva}</>}
            </div>
            <div><Link to={`/${tipologia.URL}${PAGINE.CREDITS.URL}`}>Credits</Link></div>
            <div>&copy; 2024 - Tutti i diritti riservati/All rights reserved</div>
        </div>                
    </footer>
}

export default Footer